<template>
  <div class="py-5" ref="postContainer">
    <div class="container">
      <div class="post-image mb-4" :style="`background-image: url(${post.image || defaultBanner });`">
      </div>
      <div class="row mt-4">
        <div class="col-md-9">
          <div>
            <h1 class="post-title" v-if="lang === 'en' || !post.title_es">{{ post.title }}</h1>
            <h1 class="post-title" v-if="lang === 'es' && post.title_es">{{ post.title_es }}</h1>
          </div>

          <div class="mt-4 post-content" v-html="post.content" v-if="lang !== 'es' || !post.content_es">
          </div>

          <div class="mt-4 post-content" v-html="post.content_es" v-if="lang === 'es' && post.content_es">
          </div>

          <hr class="mt-4"/>

          <div class="mb-4">
            <div class="mb-2">Share:</div>
            <social-sharing :url="currentUrl" inline-template>
              <div>
                <network network="facebook" class="mr-1 btn btn-sm btn-primary">
                  <i class="fab fa-fw fa-facebook"></i> Facebook
                </network>
                <network network="linkedin" class="mr-1 btn btn-sm btn-secondary">
                  <i class="fab fa-fw fa-linkedin"></i> LinkedIn
                </network>
                <network network="pinterest" class="mr-1 btn btn-sm btn-danger">
                  <i class="fab fa-fw fa-pinterest"></i> Pinterest
                </network>
                <network network="reddit" class="mr-1 btn btn-sm btn-default">
                  <i class="fab fa-fw fa-reddit"></i> Reddit
                </network>
                <network network="twitter" class="mr-1 btn btn-sm btn-info">
                  <i class="fab fa-fw fa-twitter"></i> Twitter
                </network>
                <network network="vk" class="btn btn-sm btn-default">
                  <i class="fab fa-vk"></i> VKontakte
                </network>
                <!-- <network network="weibo" class="btn btn-sm">
                  <i class="fab fa-weibo"></i> Weibo
                </network> -->
                <!-- <network network="whatsapp" class="btn btn-sm">
                  <i class="fab fa-fw fa-whatsapp"></i> Whatsapp
                </network> -->
              </div>
            </social-sharing>
          </div>

          <div class="card card-post card-round mt-2" v-if="post.author">
            <div class="card-body">
              <h3 class="fw-light">{{ $t('author') }}</h3>
              <div class="d-flex mt-3">
                <div class="avatar">
                  <img :src="post.author.profile_image || defaultImage" alt="..." class="avatar-img rounded-circle">
                </div>
                <div class="info-post ml-2">
                  <p class="username">{{ getAuthor(post) }}</p>
                  <p class="date text-muted">{{ moment.utc(post.publishing_date).format('LL') }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <h2 class="fw-light">{{ $t('more_articles') }}</h2>
          <div class="mt-3" v-for="(item, index) in posts" v-bind:key="`${index}_post`">
            <div class="card card-post card-round card-recommendations">
              <router-link :to="`/blog/${item.key}`">
                <img class="card-img-top" :src="item.image" :alt="item.title" v-if="item.image">
              </router-link>
              <div class="card-body">
                <div class="d-flex">
                  <div class="avatar">
                    <img :src="item.author.profile_image || defaultImage" alt="..." class="avatar-img rounded-circle">
                  </div>
                  <div class="info-post ml-2">
                    <p class="username">{{ getAuthor(item) }}</p>
                    <p class="date text-muted">{{ moment.utc(item.publishing_date).format('LL') }}</p>
                  </div>
                </div>
                <div class="separator-solid"></div>
                <!-- <p class="card-category text-info mb-1">
                  <router-link :to="`/blog/${item.key}`">{{ moment(item.publishing_date).format('LL') }}</router-link>
                </p> -->
                <h4 class="card-title">
                  <router-link :to="`/blog/${item.key}`">
                    {{ item.title }}
                  </router-link>
                </h4>
                <p class="card-text">
                  {{ getText(item) | truncate(150) }}
                </p>
                <router-link :to="`/blog/${item.key}`" class="btn btn-primary btn-rounded btn-sm">
                  {{ $t('read_more') }}
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Blog from '../services/blog'
import Filters from '../components/utils/filters'
import moment from 'moment'
import _ from 'underscore'

export default {
  name: 'Blog',
  data: function () {
    return {
      currentUrl: '',
      defaultImage: '/static/img/img-placeholder-dark.jpg',
      defaultBanner: '/static/img/blog/default-banner.jpg',
      post: {},
      moment: moment,
      lang: '',
      posts: []
    }
  },
  methods: {
    getAuthor: function (item) {
      let name = ''

      if (item.author.name) {
        name = item.author.name

        if (item.author.last_name) {
          name += ' ' + item.author.last_name
        }
      } else {
        name = item.author.username
      }

      return name
    },
    getText: function (item) {
      if (item.description) {
        return item.description
      } else {
        return window.$(item.content).text()
      }
    },
    getPost: function () {
      this.post = {}

      Blog.get(this.$route.params.key).then(response => {
        this.post = response.data

        if (this.lang === 'es' && this.post.title_es) {
          window.document.title = this.post.title_es + ' | Indiefy Blog'
          window.$('meta[property="og:title"]').attr('content', this.post.title_es + ' | Indiefy Blog')
        } else {
          window.document.title = this.post.title + ' | Indiefy Blog'
          window.$('meta[property="og:title"]').attr('content', this.post.title + ' | Indiefy Blog')
        }

        if (this.lang === 'es' && (this.post.description_es || this.post.content_es)) {
          window.$('meta[name="description"]').attr('content', this.post.description_es || window.$(this.post.content_es).text().substr(0, 250))
          window.$('meta[property="og:description"]').attr('content', this.post.description_es || window.$(this.post.content_es).text().substr(0, 250))
        } else {
          window.$('meta[name="description"]').attr('content', this.post.description || window.$(this.post.content).text().substr(0, 250))
          window.$('meta[property="og:description"]').attr('content', this.post.description || window.$(this.post.content).text().substr(0, 250))
        }

        if (this.post.content.image) {
          window.$('meta[property="og:image"]').attr('content', this.post.image)
          window.$('meta[property="og:image:url"]').attr('content', this.post.image)
          window.$('meta[itemprop="image"]').attr('content', this.post.image)
          window.$('meta[property="og:image:type"]').attr('content', 'image/jpg')
        }

        setTimeout(() => {
          window.$('.post-content img').css('max-width', '100%')
          window.prerenderReady = true
        }, 10)
      })

      Blog.getAll({ random: 1 }).then(response => {
        this.posts = _.filter(response.data.items, item => item.key !== this.$route.params.key)
      })
    }
  },
  watch: {
    '$route': function () {
      this.getPost()
    }
  },
  created: function () {
    if (this.$i18n) {
      this.lang = this.$i18n.locale
    }

    if (this.$route.query.lang) {
      this.lang = this.$route.query.lang
    }

    if (this.lang !== 'en' && this.lang !== 'es') {
      window.$('link[rel="alternate"]').each((index, item) => {
        if (item.hreflang !== 'es' && item.hreflang !== 'en') {
          window.$(item).remove()
        }
      })

      this.lang = 'en'
    }

    this.currentUrl = window.location.href

    this.getPost()
  },
  filters: {
    truncate: Filters.truncate
  }
}
</script>
<style lang="scss" scoped>
.post-image {
  width: 100%;
  height: 300px;
  background-color: #eee;
  background-size: cover;
  background-position: center center;
  position: relative;
}

.card-recommendations .card-text {
  font-size: 18px;
  font-family: medium-content-serif-font, Georgia, Cambria, "Times New Roman", Times, serif;
}

.card-recommendations .card-title > a {
  font-weight: bold;
  font-family: 'Poppins', sans-serif !important;
}

.overlay {
  position: relative;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  text-align: center;
}

.post-title {
  font-family: 'Poppins', sans-serif;
  font-size: 60px;
  font-weight: bolder;
}

@media screen and (max-width:576px) {
  .post-title {
    padding-top: 20%;
    font-size: 26px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Post.vue